import {ApplicationConfig, importProvidersFrom} from '@angular/core';
import {MatNativeDateModule} from '@angular/material/core';
import {provideAnimations} from '@angular/platform-browser/animations';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {provideRouter} from '@angular/router';
import {routes} from './app.routes';
import {LoadingIndicatorService} from './service/loading-indicator.service';
import {LoadingInterceptorFn} from './interceptor/loading.interceptor';
import {EmployeeApiAuthenticationInterceptorFn} from './interceptor/employee-api-authentication.interceptor';
import {EmployeeService} from './service/employee.service';
import {SessionStorageService} from './service/session-storage.service';
import {AdministratorApiAuthenticationInterceptorFn} from './interceptor/administrator-api-authentication.interceptor';
import {AdminService} from './service/admin.service';

/**
 * @constant
 * @description This class provides our application configuration.
 * @export
 * @name ApplicationConfig
 * @type {ApplicationConfig}
 */
export const appConfig: ApplicationConfig = {

  // Define our list of providers.
  providers: [
    importProvidersFrom(
      LoadingIndicatorService, SessionStorageService, AdminService, EmployeeService, MatNativeDateModule
    ),
    provideAnimations(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([
      LoadingInterceptorFn, AdministratorApiAuthenticationInterceptorFn, EmployeeApiAuthenticationInterceptorFn
    ]))
  ],
};
